import { createContext, type PropsWithChildren, useContext } from 'react'
import { useStoreMemo } from 'shared/hooks'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { TeamsCreateStore } from 'pages/settings/pages/teams/store/teamsCreateStore'

const TeamsCreateContext = createContext<TeamsCreateStore | null>(null)

export const useTeamsCreateContext = () => {
  const context = useContext(TeamsCreateContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with TeamsCreateProvider')

  return context
}

export const TeamsCreateProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useStoreMemo(TeamsCreateStore, entities)

  return <TeamsCreateContext.Provider value={store}>{children}</TeamsCreateContext.Provider>
}
